import { render, staticRenderFns } from "./PedidosTiendaListView.vue?vue&type=template&id=0e505110&scoped=true&lang=pug"
import script from "./PedidosTiendaListView.vue?vue&type=script&lang=js"
export * from "./PedidosTiendaListView.vue?vue&type=script&lang=js"
import style0 from "./PedidosTiendaListView.vue?vue&type=style&index=0&id=0e505110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e505110",
  null
  
)

export default component.exports